export interface GameConfig {
  canvasId: string;
  groundSize: number;
  cameraHeight: number;
  zoomMin: number;
  zoomMax: number;
  zoomDefault: number;
  showGrid: boolean;
  backgroundColor: number;

  // Tower defense
  cookieSpawnInterval: number;   // seconds between spawns
  cookieSpeed: number;           // world units per second
  cookieSpawnRadius: number;     // distance from center where cookies spawn
  trashCanCapacity: number;      // cookies before game over
  trashCanCatchRadius: number;   // distance from center that catches a cookie
  monsterBaseCost: number;       // cost of the first monster
  monsterCostMultiplier: number; // cost multiplier applied per monster placed
  monsterEatRadius: number;      // world-unit radius in which a monster eats cookies
  startingCookies: number;       // player's cookie count at game start
}

export const DEFAULT_CONFIG: GameConfig = {
  canvasId: 'game-canvas',
  groundSize: 20,
  cameraHeight: 15,
  zoomMin: 3,
  zoomMax: 20,
  zoomDefault: 10,
  showGrid: true,
  backgroundColor: 0x1a1a2e,

  cookieSpawnInterval: 2,
  cookieSpeed: 3,
  cookieSpawnRadius: 13,
  trashCanCapacity: 10,
  trashCanCatchRadius: 0.8,
  monsterBaseCost: 5,
  monsterCostMultiplier: 1.1,
  monsterEatRadius: 2.5,
  startingCookies: 5,
};
